import {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {getAccountManagerTypes} from 'src/openapi/admin/apis/GetAccountManagerTypesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectAccountManagerTypes} from './services/dictionary-slice';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const useAccountManagerTypes = () => {
    const apiDispatch = useAppDispatch();
    const accountManagerTypes = useSelector(selectAccountManagerTypes);

    const loadAccountManagerTypes = useCallback(() => {
        if (!accountManagerTypes.length) {
            apiDispatch(getAccountManagerTypes());
        }
    }, [accountManagerTypes.length, apiDispatch]);

    const getAccountManagerTypeByCode = useCallback((code: string): DictionaryItem | undefined => {
        return accountManagerTypes?.find(e => e.code === code);
    }, [accountManagerTypes]);

    const filteredAccountManagerTypes = useMemo(() => (
        accountManagerTypes?.filter(({code}) => !!code)
    ), [accountManagerTypes]);


    return {accountManagerTypes, loadAccountManagerTypes, getAccountManagerTypeByCode, filteredAccountManagerTypes};
};
